module.exports = __webpack_public_path__ + "img/8bdd5b49dba3ecce3fde84f70c7dea03.png";